import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltip } from '@angular/material/tooltip';
import { DefaultFormValueControl } from '@coin/shared/core/util-helpers';

@Component({
  selector: 'coin-v2-checkbox',
  imports: [MatCheckboxModule, FormsModule, MatTooltip],
  templateUrl: './v2-checkbox.component.html',
  styleUrls: ['./v2-checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2CheckboxComponent extends DefaultFormValueControl<boolean> {
  readonly label = input<string>();
  readonly contrast = input(false);
  readonly indeterminate = input(false);
  readonly color = input<CheckboxColor>('accent');

  protected override toViewValue(value: boolean | string): boolean {
    return castFromString(value);
  }
}

function castFromString(value: boolean | string): boolean {
  if (typeof value === 'string') return value.toLowerCase() === 'true';
  return value;
}

export const CHECKBOX_COLORS = ['accent', 'primary', 'white'] as const;
export type CheckboxColor = (typeof CHECKBOX_COLORS)[number];
